import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

export const StripeCardFormStyles = styled.form`
  transform: scale(0.99);
  margin: 10px 0 0;
`;

export const ButtonStyles = styled.button<{
  theme?: 'dark-violet' | 'domination' | 'dark-forest';
}>`
  display: flex;
  padding: 14px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 64px;
  background: linear-gradient(180deg, #a77aff 0%, #6d2ceb 100%), #db8b2d;
  color: #fff;
  margin: 12px auto 8px;
  font-size: 17px;
  line-height: 22px;
  width: 100%;
  font-weight: 600;

  &:disabled {
    opacity: 0.6;
    pointer-events: none;
  }

  ion-spinner {
    width: 20px;
    height: 20px;
    color: #fff;
  }

  ${({ theme }) =>
    theme === 'domination' &&
    `
      background: linear-gradient(95.02deg, #D9002F 0%, #7F001C 100%);
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      border-radius: 8px;
  `}

  ${({ theme }) =>
    theme === 'dark-forest' &&
    `
      background: linear-gradient(272.88deg, #686DE0 4.95%, #4834D4 93.62%);
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      border-radius: 8px;
  `}
`;

export const MessageStyles = styled(UiTypography)`
  margin: 10px 0 0;
  display: flex;
  align-items: center;

  ion-spinner {
    margin-left: 8px;
    flex-shrink: 0;
    color: inherit;
    width: 20px;
    height: 20px;
  }
`;
